import { aggregatedStatuses, Dimension } from 'mocks/server/data/aggregatedStatuses';

export const statusAggregate = async (by: string) => {
  const key = by as keyof Dimension;
  return aggregatedStatuses[key];
};
